export default{
  props: {
    showEnterprises: {
      type: Boolean,
      default: false
    },
    showCreci: {
      type: Boolean,
      default: true
    },
    corretor: {
      type: Boolean,
      default: true
    },
    userDataProp: {
      type: Object,
      default: {}
    },
    entreprisesUserArray: {
      type: Array,
      default: []
    }
  },
  mounted () {
    this.userData = JSON.parse(JSON.stringify(this.userDataProp))
    this.statusSolicitacao()
  },
  data () {
    return {
      statusText: 'Ativo',
      statusColor: {
        backgroundColor: ''
      },
      userData: {}
    }
  },
  methods: {
    statusSolicitacao () {
      if (this.corretor === false) {
        if (this.userData.status === 0) {
          this.statusText = 'Ativo'
          this.statusColor.backgroundColor = '#30a75f'
        } else {
          this.statusText = 'Inativo'
          this.statusColor.backgroundColor = '#db0000'
        }
      } else {
        if (this.userData.aprovado === false) {
          this.statusText = 'Ag. Aprovação'
          this.statusColor.backgroundColor = '#f6b535'
        } else {
          this.statusText = 'Aprovado'
          this.statusColor.backgroundColor = '#30a75f'
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/users/components/UserSummaryCard/UserSummaryCard.js